import { useContext } from 'react';

import { SelectionAreaPathRefContext } from '../context/selection-area-path-ref.context.js';

export const useSelectionAreaPathRef = () =>
  useContext(SelectionAreaPathRefContext);
